import { IBulkBatch } from "@wingspanhq/payments/dist/interfaces";
import { useQueryFlatfileSkippedRowsCount } from "../query/flatfile/queries";
import { BulkResource } from "../types";
import { getUploadRejectedRowsCount } from "../utils/bulkBatchUtils";

/**
 * Number of uploaded spreadsheet rows that did not make it into the batch, and whether that number
 * is still on its way.
 *
 * Prefers the live Flatfile count, which sees both the rows that failed validation and the rows the
 * Wingspan API refused, and falls back to the `flatfileRejectedRowsCount` batch label - which only
 * ever counted the latter - when Flatfile cannot be reached. The label is durable, so an old batch
 * whose space is gone keeps reporting what it reports today instead of dropping to nothing.
 *
 * While the live count loads the label is returned as the count, so callers that show a number can
 * wait on the flag instead of showing the label's lower number and correcting it a round-trip later.
 */
export function useSkippedRowsCount(
  bulkBatch?: IBulkBatch,
  bulkResource?: BulkResource
): { skippedRowsCount: number; isSkippedRowsCountLoading: boolean } {
  const queryFlatfileSkippedRowsCount = useQueryFlatfileSkippedRowsCount(
    bulkBatch,
    bulkResource
  );

  return {
    skippedRowsCount:
      queryFlatfileSkippedRowsCount.data ??
      getUploadRejectedRowsCount(bulkBatch),
    // isInitialLoading rather than isLoading: in react-query v4 a disabled query (no Flatfile token,
    // upload still running) also reports isLoading, and that case is the label's to answer
    isSkippedRowsCountLoading: queryFlatfileSkippedRowsCount.isInitialLoading
  };
}
